import { Component, EventEmitter, Input, Output } from "@angular/core";
import { UiKitModule } from "@app/ui-kit.module";

@Component({
  selector: "app-add-button",
  templateUrl: "./add-button.component.html",
  styleUrl: "./add-button.component.scss",
  imports: [UiKitModule],
  standalone: true,
})
export class AddButtonComponent {
  @Output() add = new EventEmitter<void>();
  @Output() dragStart = new EventEmitter<void>();
  @Input() disabled?: boolean;

  clickAdd() {
    this.add.emit();
  }

  onDragStart() {
    this.dragStart.emit();
  }
}
